export const transformLanguageCode = (languageCode: string, toLowerCase?: boolean): string => {
    const splitLanguage = languageCode.split('-');
    const countryLanguageCode = toLowerCase
        ? splitLanguage[1].toLowerCase()
        : splitLanguage[1].toUpperCase();

    return `${splitLanguage[0]}-${countryLanguageCode}`;
};

export const getTwoLetterLanguageCode = (languageCode: string): string => {
    const splitLanguage = languageCode.split('-');

    return `${splitLanguage[0].toLowerCase()}`;
};
